import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';

@Component({
  templateUrl: './confirm-banner.component.html',
  styleUrls: ['./confirm-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LayoutAlignDirective, MatButton]
})
export class ConfirmBannerComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: string,
    public snackBarRef: MatSnackBarRef<ConfirmBannerComponent>
  ) {
  }

  confirm() {
    this.snackBarRef.dismissWithAction();
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
